import {
  BANK_ALL,
  BANK_GET,
  BANK_PUT,
  BANK_POST,
  BANK_DEL,
  BANK_LOADING,
  BANK_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const bankCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: BANK_LOADING });
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/bank`, {
      ...payload,
    });
    dispatch({ type: BANK_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BANK_ERROR });
    throw new Error(error);
  }
};

export const bankAll = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/bank`,
    );
    if (status === 200) {
      dispatch({ type: BANK_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BANK_ERROR });
    throw new Error(error);
  }
};

export const bankGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/bank/${id}`,
    );
    if (status === 200) {
      dispatch({ type: BANK_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BANK_ERROR });
    throw new Error(error);
  }
};

export const bankPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: BANK_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/bank/${id}`,
      payload,
    );
    dispatch({ type: BANK_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BANK_ERROR });
    throw new Error(error);
  }
};

export const bankDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: BANK_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/bank/${id}`,
    );
    dispatch({ type: BANK_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BANK_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
